/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, Grid, makeStyles } from '@material-ui/core';
import React, { useState } from 'react'
import ReactDatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { useTranslation } from 'react-i18next'
// import {FR} from '../../utils/DateLocale'
import { fr, enGB } from 'date-fns/locale';
import { useQuery } from '../../utils/App';
import { useHistory } from 'react-router-dom';

registerLocale("fr", fr)
registerLocale("en", enGB)

const useStyles = makeStyles(() =>
    createStyles({
        input: {
            display: "flex",
            flexDirection: "column"
        },
        span: {
            color: "#000000",
            fontSize: 14,
            marginBottom: 6
        },
        date: {
            padding: 9,
            borderRadius: 4,
            border: "1px solid #EA7606"
        }
    })
);

const DatePicker = ReactDatePicker as unknown as React.ComponentType<any>;

export const PnBDateRange = (props: { dci: string, dco: string; changeValue: (n: string, d: string) => void; }) => {
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const classes = useStyles();
    let query = useQuery();
    const history = useHistory();
    const { t } = useTranslation<'common'>();

    React.useEffect(() => {
        if (!props.dci || !props.dco) return
        setStartDate(new Date(props.dci))
        setEndDate(new Date(props.dco))
    }, [props.dci, props.dco])

    const onChandeDate = (n: string, d: any) => {
        if (n === 'dci') {
            setStartDate(d)
        } else {
            setEndDate(d)
        }
        props.changeValue(n, moment(d).format('YYYY/MM/DD'));
    }

    React.useEffect(() => {
        if (startDate && endDate) {
            if (endDate < startDate) {
                setEndDate(new Date(props.dci))

                query.set('dco', moment(props.dci).format('YYYY/MM/DD'))
                history.push({ search: query.toString() });
            }
        }
    }, [startDate, endDate, props.dci])
    return (
        <>
            <Grid item md={6} lg={6} sm={6} xs={6} className={classes.input}>
                <h3 className={classes.span}>
                    {t('searchBar.checkIn')}
                </h3>
                <DatePicker
                    className={classes.date}
                    dateFormat="dd/MM/yyyy"
                    selected={startDate}
                    onChange={(date: any) => date ? onChandeDate('dci', date || new Date()) : null}
                    selectsStart
                    name="dci"
                    startDate={startDate}
                    endDate={endDate}
                    locale={`${t("calendar.locale.key")}`}
                    autoComplete='off'
                    minDate={new Date()}
                />
            </Grid>
            <Grid item md={6} lg={6} sm={6} xs={6} className={classes.input}>
                <h3 className={classes.span}>
                    {t('searchBar.checkOut')}
                </h3>
                <DatePicker
                    className={classes.date}
                    dateFormat="dd/MM/yyyy"
                    selected={endDate}
                    onChange={(date: any) => date ? onChandeDate('dco', date || new Date()) : null}
                    selectsEnd
                    name="dco"
                    startDate={startDate}
                    endDate={endDate}
                    autoComplete='off'
                    minDate={startDate || new Date()}
                    locale={`${t("calendar.locale.key")}`}
                />
            </Grid>
        </>
    );
}